<div class="legal-links">
    <a [href]="legalLinksSignal()?.Privacy_Url" target="_blank">
        {{'Kreditor.Footer.Privacy' | translate}}
    </a>

    @if (legalLinksSignal()?.DisplayCookieInfo.isTruthy()) {
        <a (click)="openCookiePolicy()">
            {{ 'Kreditor.Footer.CookiePolicy' | translate }}
        </a>
    }
</div>